import React from "react";
import { Form } from "antd";
import ShopType from "@/enum/ShopType";
import OrderTagSelect from "./OrderTagSelect";

export enum OrderTagSearchType {
    Include = "Include",
    UnInclude = "UnInclude",
}

interface OrderTagSelectFieldProps {
    shopType?: ShopType;
}

/** 包含订单标签 */
const OrderTagSelectField: React.FC<OrderTagSelectFieldProps> = (props) => {
    const { shopType } = props;

    return (
        <Form.Item name="orderTags" label={<span className="search-field-label">包含标签</span>}>
            <OrderTagSelect shopType={shopType} />
        </Form.Item>
    );
};

export default React.memo(OrderTagSelectField);
